import React from "react";
import "./Template_2.css";

const Template_2_Header = () => {
  return (
    <header className="Template_2 header-template-2">
      <div className="Template_2container">
        <div className="Template_2 header-content">
          <div className="Template_2 logo">
            <i className="fas fa-compass"></i>
            VoyageVista
          </div>
          <nav>
            <ul>
              <li>
                <a href="/template_2_homepage">Home</a>
              </li>
              <li className="dropdown">
                <a href="#" className="dropdown-toggle">
                  Holiday Tours
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a href="#domestic">Domestic</a>
                  </li>
                  <li>
                    <a href="#international">International</a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="/template_2_destinations">Destinations</a>
              </li>
              <li>
                <a href="#about">About Us</a>
              </li>
              <li>
                <a href="#reviews">Reviews</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Template_2_Header;
